import React from 'react';
import _ from 'underscore';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { MobileSettingsSubspaceState } from '~src/settings/mobile-settings/MobileSettingsSubspaceShared';

import { SessionManagementService } from '../../../../../sessionManagement/SessionManagementService';


interface MobileServerSettingsSubspaceOwnProps {
  readonly server: SessionManagementService;
  readonly isSessionMultiSite: boolean;
}

export class MobileServerSettingsSubspaceComponent extends React.PureComponent<MobileServerSettingsSubspaceOwnProps, MobileSettingsSubspaceState> {

  private unmounted: boolean = false;

  private initialState: MobileSettingsSubspaceState = {
    isServerPage: true,
    isMultiSite: undefined,
    hasDataToRender: false,
    hasError: false,
    siteSettingsForSiteAdmin: undefined,
  };

  public constructor(props: MobileServerSettingsSubspaceOwnProps) {
    super(props);
    this.state = {
      ...this.initialState,
      isMultiSite: props.isSessionMultiSite
    };
  }

  public componentDidMount() {
    // getData(
    //   (newState) => { this.updateState(newState as MobileSettingsSubspaceState); },
    //   () => { this.updateState({hasError: true}); }
    // );
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public componentDidUpdate() {
    if ((!_.isUndefined(this.state.siteSettingsForSiteAdmin) || !FeatureFlags.mobileSecuritySettingsEnabled)
    ) {
      this.updateState({hasDataToRender: true});
    }
  }

  public render() {
    // if (!this.state.hasDataToRender) {
    //   return null;
    // } else if (this.state.hasError) {
    //   return <RouterError errorType={'server-default'} urls={undefined}/>;
    // }

    return (
      <div>{'Hello world!!!'}</div>
    );
  }

  private updateState<K extends keyof MobileSettingsSubspaceState>(newState: Pick<MobileSettingsSubspaceState, K>, callback?: () => void): void {
    if (!this.unmounted) {
      this.setState(newState, callback);
    }
  }
}
